module.exports = __webpack_public_path__ + "img/impact.5b914579.png";